import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { DriverLocation } from '../lib/types';

interface UseDriverLocationResult {
  location: DriverLocation | null;
  loading: boolean;
  error: string | null;
}

export function useDriverLocation(driverId: string | undefined): UseDriverLocationResult {
  const [location, setLocation] = useState<DriverLocation | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!driverId) { setLoading(false); return; }

    async function fetchLocation() {
      const { data, error: err } = await supabase
        .from('driver_locations')
        .select('*')
        .eq('driver_id', driverId)
        .maybeSingle();

      setLocation(err ? null : (data as DriverLocation | null));
      if (err) setError(err.message);
      setLoading(false);
    }

    fetchLocation();

    const channel = supabase
      .channel(`driver-loc-${driverId}`)
      .on('postgres_changes', { event: '*', schema: 'public', table: 'driver_locations', filter: `driver_id=eq.${driverId}` },
        (payload) => setLocation(payload.new as DriverLocation)
      )
      .subscribe();

    return () => { supabase.removeChannel(channel); };
  }, [driverId]);

  return { location, loading, error };
}
